import React, { memo } from 'react';

import PropTypes from 'prop-types';
import { defaultCurrency } from '../../../default-props/default-currency';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';

import { FileAClaimButton } from '../../../insurance/components/file-a-claim-button';
import { InsuranceProviders } from '../../../enums/insurance-providers';
import { MessageDescriptorPropType } from '../../../prop-types/intl';
import Global from '../../../store/global-selectors';
import FormattedCurrencyContainer from '../../formatted-currency/container';

const InsuranceButtonText = ({ insuranceProviderMessage, currencyCode, currencyValue }) => {
  return (
    <span>
      {insuranceProviderMessage && <FormattedMessage {...insuranceProviderMessage} />}{' '}
      <FormattedCurrencyContainer currencyCode={currencyCode} value={currencyValue} />
    </span>
  );
};

InsuranceButtonText.propTypes = {
  insuranceProviderMessage: PropTypes.oneOfType([PropTypes.string, MessageDescriptorPropType]).isRequired,
  currencyCode: PropTypes.string.isRequired,
  currencyValue: PropTypes.number.isRequired,
};

const InsuranceColumn = ({ data }) => {
  const isPersonalShipsuranceAccount = useSelector(Global.selectSellerPersonalShipsuranceAccount);
  const insuranceProviderId = data.insuranceProviderId || InsuranceProviders.None.insuranceProviderId;
  if (insuranceProviderId === InsuranceProviders.None.insuranceProviderId) {
    return '';
  }

  const insuranceProvider = Object.values(InsuranceProviders).find(
    (provider) => provider?.insuranceProviderId === `${insuranceProviderId}`,
  );
  const insuranceProviderMessage = insuranceProvider?.messageDescriptor;

  const insuredAmount = data.insuredAmount ?? defaultCurrency;
  const { value, code } = insuredAmount;

  if (InsuranceProviders[insuranceProvider?.name]?.canFileAClaim && !isPersonalShipsuranceAccount) {
    return (
      <FileAClaimButton fulfillmentPlanIdProp={data.fulfillmentPlanId} insuranceProviderName={insuranceProvider.name}>
        {({ url, open }) => (
          <Button href={url} onClick={open} theme='link'>
            <InsuranceButtonText currencyCode={code} currencyValue={value} insuranceProviderMessage={insuranceProviderMessage} />
          </Button>
        )}
      </FileAClaimButton>
    );
  }
  return <InsuranceButtonText currencyCode={code} currencyValue={value} insuranceProviderMessage={insuranceProviderMessage} />;
};

InsuranceColumn.propTypes = {
  data: PropTypes.shape({
    fulfillmentPlanId: PropTypes.string,
    insuranceBookingId: PropTypes.string,
    insuranceClaimInitiationUrl: PropTypes.string,
    insuranceProviderId: PropTypes.string,
    insuranceTransactionId: PropTypes.string,
    insuredAmount: PropTypes.shape({
      value: PropTypes.number,
      code: PropTypes.string,
    }),
  }).isRequired,
};

export default memo(InsuranceColumn);
